export default function TermsOfService() {
  return (
    <main style={{ maxWidth: 720, margin: '0 auto', padding: '2rem' }}>
      <h1>Terms of Service</h1>
      <p>This page is a placeholder. Add the full Terms of Service content here later.</p>
    </main>
  );
}